module.exports = __webpack_public_path__ + "static/wp-483afea80aa777d414cbe5bcef8e70a3.jpg";